import { AppState } from '../../app/state/AppState';
import { Messages } from '../../codegen/Localize';
import { EntityActionNames, IEntityAction } from '../../spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { runFlowTaskResume } from '../actions/RunFlowTaskMenuActions';
import { RunFlowTaskInfo } from '../models/RunFlowTaskInfo';

export const RunFlowTaskResumeAction: IEntityAction<RunFlowTaskInfo, {}> = {
  name: EntityActionNames.TasksResume,
  translateName: Messages.runFlowTasksResumeAction,
  isVisible: (targetItems: RunFlowTaskInfo[], state: AppState) => {
    return targetItems.length > 0;
  },
  isClickable: (_availableActions: {}, targetItems: RunFlowTaskInfo[]) => {
    const singleSuspendedItem = targetItems.length === 1 && targetItems[0].suspended;
    return targetItems.length !== 1 || singleSuspendedItem;
  },
  createReduxAction: (targetItems: RunFlowTaskInfo[]) => runFlowTaskResume(targetItems)
};
